<template lang="pug">
  v-layout.mute-lead-assist(v-if="isLeadAssistConnected")
    v-flex(xs5 row)
      div.mt-2
        v-icon.pr-2 assistant
        | LionDesk Lead Assist
        sup TM
        | :
    v-flex
      v-switch.mt-1(
        data-cy="toggle-mute-lead-assist"
        v-model="isContactActive"
        color="primary"
      )
        template(slot="label")
          span(v-if="isLoading") One moment please...
          span(v-else-if="isContactActive") Active
          span(v-else) Muted
    v-snackbar(:value="!!leadAssistError" color="error")
      div {{ leadAssistError }}
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  watch: {
    contact: {
      async handler(contact) {
        if (contact.mobile_phone) {
          await this.getLeadAssistLead({
            currentUserId: this.currentUser.id,
            assignedUserId: contact.assigned_user_id,
            contactPhone: contact.mobile_phone.replace(/[^0-9]/g, ''),
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      isLoading: state => state.leadAssist.isLoading,
      leadAssistLead: state => state.leadAssist.lead,
      isContactMuted: state => state.leadAssist.isContactMuted,
      leadAssistError: state => state.leadAssist.error,
    }),
    isContactActive: {
      get() {
        return !this.isContactMuted;
      },
      async set(value) {
        await this.toggleMuteLeadAssist({
          leadId: this.leadAssistLead.id,
          isMuted: !this.leadAssistLead.muted,
        });
      },
    },
    /**
     * only show mute/unmute btn if user is connected to lead assist and the
     * contact in the convo is a lead assist contact
     */
    isLeadAssistConnected() {
      return !!this.currentUser.structurely_forwarding_email && !!this.leadAssistLead;
    },
  },
  methods: {
    ...mapActions('leadAssist', ['getLeadAssistLead', 'toggleMuteLeadAssist']),
  },
};
</script>

<style scoped lang="scss">
.mute-lead-assist {
  color: rgba(0, 0, 0, 0.54);
  font-size: 16px;
  padding: 0 0 0 5px;
}
</style>
